import Collapse from 'react-bootstrap/Collapse';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { KPPlanetLinks } from './KPPlanetLinks';
import { KPCuspalLinksStarLord } from './KPCuspalLinksStarLord';
import { KPCuspalLinksSubLord } from './KPCuspalLinksSubLord';
import { KPCuspalLinksSubSubLord } from './KPCuspalLinksSubSubLord';

export function KPLinksChart ({menuArray,userData}) {
  return(
    <>
      { userData===null || userData===undefined?<></>:
          <Collapse in={menuArray[6]} className="m-0 p-0 ">
            <div id="cuspalLinks" className="m-0 p-0">
              <Row id="row1" className="m-0 p-0 ">
                  <Col xs={12} md={6} className="p-2 pt-0 m-0">
                    <KPPlanetLinks userData={userData}/>
                  </Col>
                  <Col xs={12} md={6} className="p-2 pt-0 m-0">
                    <KPCuspalLinksSubLord userData={userData}/>
                  </Col>
              </Row>
              <Row id="row2" className="m-0 p-0">
                  <Col xs={12} md={6} className="p-2 pt-0 m-0">
                    <KPCuspalLinksStarLord userData={userData}/>
                  </Col>
                  <Col xs={12} md={6} className="p-2 pt-0 m-0">
                    <KPCuspalLinksSubSubLord userData={userData}/>
                  </Col>
              </Row>
            </div>  
          </Collapse>
    }
  </>  
  );
}